module.exports = __webpack_public_path__ + "img/show_cn_text_5.dca049fb.png";